import {combineReducers} from 'redux'
import types from 'actions/types'

export const shopifyStatus = (state = null, action) => {
  switch (action.type) {
    case types.SHOPIFY_ENABLED_SUCCESS:
      return action.data
    case types.SHOPIFY_DISABLE_SUCCESS:
      return action.data
    case types.SHOPIFY_STATUS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  shopifyStatus,
})
